@if (recipients().length === 0) {
  <span class="text-text-tertiary">—</span>
} @else if (hiddenCount() === 0) {
  <span class="break-all select-all">{{ recipients()[0].email }}</span>
} @else {
  <span
    #trigger
    data-testid="deploy-recipients-trigger"
    class="group inline-flex max-w-full cursor-help items-start gap-1">
    <span class="break-all">{{ recipients()[0].email }}</span>
    <span
      class="border-default bg-elevated text-text-tertiary group-hover:border-strong group-hover:text-text-secondary mt-px shrink-0 rounded-full border px-1.5 py-px text-[10px] font-medium transition-colors">
      +{{ hiddenCount() }}
    </span>
  </span>

  <app-tooltip
    [target]="trigger"
    [title]="
      'features.plan.deploy.table.recipients_all'
        | translate: { count: recipients().length }
    "
    [content]="tooltipHtml()"
    [position]="'bottom-start'"
    [maxWidth]="360" />
}
